const palleteColors = [
    {
        id: 1,
        color: "#C6D57E"
    },
    {
        id: 2,
        color: "#89A3B2"
    },
    {
        id: 3,
        color: "#DE8971"
    },
    {
        id: 4,
        color: "#7C9473"
    },
    {
        id: 5,
        color: "#EEBB4D"
    },
    {
        id: 6,
        color: "#F1935C"
    },
    {
        id: 7,
        color: "#AC8DAF"
    },
    {
        id: 8,
        color: "#FCD1D1"
    },
    {
        id: 9,
        color: "#FFFFFF"
    },
    {
        id: 10,
        color: "#EF6C57"
    }

];

export default palleteColors;